import { useSnackbar } from 'notistack';
import { useState } from 'react';
import axiosInstance from 'src/utils/axios';
import { APIS } from 'src/utils/serviceUrls';
import { Blog } from '../../../@types/blog';

export const useBlogs = () => {
  const [blogs, setBlogs] = useState<Blog[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [filterName, setFilterName] = useState('');
  const [filterRole, setFilterRole] = useState('all');
  const [currentBlog, setCurrentBlog] = useState<Blog | undefined>();
  const [filteredData, setFilteredData] = useState<Blog[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  const getBlogList = async () => {
    const response = await axiosInstance.get(APIS.BLOGS.LIST);
    setBlogs(response.data.data);
    setFilteredData(response.data.data);
  };

  const filterResult = (name: string) =>
    blogs.filter((blog) => blog.title.toLowerCase().includes(name.toLowerCase()));

  const handleFilterName = (filterName: string) => {
    setFilterName(filterName);

    setFilteredData(filterResult(filterName));
  };

  const handleEditRow = (selected: Blog) => {
    setCurrentBlog(selected);
    setModalOpen(true);
  };
  const handleDeleteRow = async (id: string) => {
    try {
      await axiosInstance.delete(APIS.BLOGS.PATCH(id));
      await axiosInstance.post(APIS.SUPPORT.handleDelete, {
        blog: id,
        type: 'BLOG',
      });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error?.message || 'Deleted Successfully', { variant: 'success' });
    }
    setConfirmationOpen(true);
  };

  return {
    modalOpen,
    setModalOpen,
    confirmationOpen,
    setConfirmationOpen,
    filterName,
    filterRole,
    currentBlog,
    setCurrentBlog,
    filteredData,
    handleDeleteRow,
    handleEditRow,
    handleFilterName,
    getBlogList,
  };
};
